/* ==========================================================================
   LUNDRA — Sélecteur d'offre + barre d'achat mobile + apparition douce
   Aucune dépendance. Utilise l'AJAX Cart API native de Shopify.
   ========================================================================== */
(function () {
  'use strict';

  /* ----------------------------------------------------------------------
     1. Sélecteur d'offre
     Chaque option porte data-lu-items = JSON : [{ id: <variantId>, quantity: n }]
     et data-lu-vue côté image pour afficher la photo correspondante.

     Si la section porte data-lu-remplacer, le panier est vidé avant l'ajout :
     le visiteur repart toujours avec exactement l'offre qu'il a choisie,
     même s'il clique plusieurs fois ou change d'avis.
     ---------------------------------------------------------------------- */
  function initSelecteur(racine) {
    var form = racine.querySelector('[data-lu-form]');
    var bouton = racine.querySelector('[data-lu-ajouter]');
    var zoneErreur = racine.querySelector('[data-lu-erreur]');
    var options = racine.querySelectorAll('input[type="radio"][data-lu-items]');
    var vues = racine.querySelectorAll('[data-lu-vue]');
    var remplacer = racine.hasAttribute('data-lu-remplacer');
    if (!form || !bouton || !options.length) return;

    if (form.dataset.luInitialise) return;
    form.dataset.luInitialise = "1";

    var texteInitial = bouton.textContent.trim();

    function optionActive() {
      for (var i = 0; i < options.length; i++) {
        if (options[i].checked) return options[i];
      }
      return null;
    }

    function majImage(cle) {
      if (!vues.length) return;
      var trouve = false;
      for (var i = 0; i < vues.length; i++) {
        if (vues[i].getAttribute('data-lu-vue') === cle) trouve = true;
      }
      // Si aucune image dédiée n'existe pour ce choix, on garde celle du pack.
      var cible = trouve ? cle : 'pack';
      for (var j = 0; j < vues.length; j++) {
        var actif = vues[j].getAttribute('data-lu-vue') === cible;
        vues[j].classList.toggle('est-active', actif);
        vues[j].setAttribute('aria-hidden', actif ? 'false' : 'true');
      }
    }

    function synchroniser() {
      var choix = optionActive();
      if (!choix) return;

      majImage(choix.value);
      racine.querySelectorAll('[data-lu-resume]').forEach(function (bloc) {
        bloc.hidden = bloc.getAttribute('data-lu-resume') !== choix.value;
      });
      racine.querySelectorAll('[data-lu-pour]').forEach(function (bloc) {
        bloc.hidden = bloc.getAttribute('data-lu-pour').split(' ').indexOf(choix.value) === -1;
      });

      // Met à jour la barre mobile si elle est présente
      var barre = document.querySelector('[data-lu-barre-mobile]');
      if (barre) {
        var prix = barre.querySelector('[data-lu-barre-prix]');
        var note = barre.querySelector('[data-lu-barre-note]');
        if (prix && choix.dataset.luPrix) prix.textContent = choix.dataset.luPrix;
        if (note && choix.dataset.luNom) note.textContent = choix.dataset.luNom;
      }
    }

    options.forEach(function (opt) { opt.addEventListener('change', synchroniser); });
    var param = new URLSearchParams(window.location.search).get('offre');
    var alias = { baskets: 'produit-1', casquettes: 'produit-2', duo: 'pack' };
    if (alias[param]) options.forEach(function (opt) { opt.checked = opt.value === alias[param]; });
    synchroniser();

    form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      if (bouton.disabled) return;

      var choix = optionActive();
      if (!choix) return;

      var items;
      try {
        items = JSON.parse(choix.dataset.luItems);
      } catch (e) {
        items = [];
      }
      items = items.filter(function (it) { return it && it.id; });

      if (!items.length) {
        zoneErreur.textContent = "Cette offre n'est pas encore configurée. Sélectionnez un produit dans l'éditeur de thème.";
        return;
      }

      zoneErreur.textContent = '';
      bouton.disabled = true;
      bouton.textContent = 'Ajout en cours…';

      var racineUrl = window.Shopify.routes.root;
      var prepare = remplacer
        ? fetch(racineUrl + 'cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
        : Promise.resolve();

      prepare
        .then(function () {
          return fetch(racineUrl + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error(data.description || data.message || 'Ajout impossible.');
            return data;
          });
        })
        .then(function () {
          window.location.href = racineUrl + 'cart';
        })
        .catch(function (err) {
          zoneErreur.textContent = err.message + ' Vérifiez le stock disponible, ou contactez-nous.';
          bouton.disabled = false;
          bouton.textContent = texteInitial;
        });
    });
  }

  /* ----------------------------------------------------------------------
     2. Barre d'achat mobile : apparaît une fois le hero dépassé,
        disparaît quand le sélecteur est à l'écran.
     ---------------------------------------------------------------------- */
  function initBarreMobile() {
    var barre = document.querySelector('[data-lu-barre-mobile]');
    if (!barre) return;
    var cible = document.querySelector('[data-lu-selecteur]');
    var declencheur = document.querySelector('[data-lu-hero]') || cible;
    if (!declencheur) return;

    var heroPasse = false;
    var selecteurVisible = false;

    function majAffichage() {
      barre.classList.toggle('est-visible', heroPasse && !selecteurVisible);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entrees) {
        heroPasse = !entrees[0].isIntersecting;
        majAffichage();
      }, { rootMargin: '0px 0px -70% 0px' }).observe(declencheur);

      if (cible) {
        new IntersectionObserver(function (entrees) {
          selecteurVisible = entrees[0].isIntersecting;
          majAffichage();
        }, { threshold: 0.25 }).observe(cible);
      }
    } else {
      barre.classList.add('est-visible');
    }

    var lien = barre.querySelector('[data-lu-barre-lien]');
    if (lien && cible) {
      lien.addEventListener('click', function (evt) {
        evt.preventDefault();
        cible.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  /* ----------------------------------------------------------------------
     3. Apparition douce au défilement
     ---------------------------------------------------------------------- */
  function initApparition() {
    var elements = document.querySelectorAll('.lundra__apparait');
    if (!elements.length) return;
    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      elements.forEach(function (el) { el.classList.add('est-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('est-visible'); obs.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    elements.forEach(function (el) { obs.observe(el); });
  }

  function demarrer() {
    document.querySelectorAll('[data-lu-selecteur]').forEach(initSelecteur);
    initBarreMobile();
    initApparition();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }

  // Rejoue l'initialisation quand l'éditeur de thème recharge une section
  document.addEventListener('shopify:section:load', demarrer);
})();
